import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import md5 from 'crypto-js/md5';
import aes from 'crypto-js/aes';
// import NodeRSA from 'node-rsa';
import api from '../api';

// 设置公钥
// const pem = `-----BEGIN PUBLIC KEY-----
// MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDJuYYs3NoRMLVBCPqpROHu3K5V
// 50ZxluIPC6I13vl0vuu1XuAt88gpC5zERI9x8KSzzhHRKAKmbvTCKHDTJINwCfvu
// OhzjxUPNxWvLVF1aioIVsdmAqpkYsislydtOSB8VNT0sELDbHRWS5+6USYs92hLy
// 1/mK/AATLsvKR0KmlQIDAQAB
// -----END PUBLIC KEY-----`;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    keepAliveInclude: [],
    loginForm: null,
    person: {},
    toHome: false,
    pos: null,
    recruit: null,
    h5Ver: '',
    inviteCode: 0,
    leaderStatus: 0,
    authenStatus: 0,
    signStatus: 0
  },
  modules: {},
  mutations: {
    updateKeepAliveInclude: (state, data) => {
      state.keepAliveInclude = data;
    },
    updateLoginForm: (state, data) => {
      state.loginForm = data;
    },
    updatePerson: (state, data) => {
      state.person = data;
    },
    updateToHome: (state, data) => {
      state.toHome = data;
    },
    updatePos: (state, data) => {
      state.pos = data;
    },
    updateRecruit: (state, data) => {
      state.recruit = data;
    },
    updateH5Ver: (state, data) => {
      state.h5Ver = data;
    },
    updateInviteCode: (state, data) => {
      state.inviteCode = data;
    }
  },
  actions: {
    async getData({ commit, rootState }, { url }) {
      try {
        let res = await api.get(url);
        if (res) {
          if (res.code === 10000) {
            return res.data;
          } else {
            throw new Error(res.message || '请求失败');
          }
        }
      } catch (error) {
        throw error;
      }
    },
    async postData({ commit, rootState }, { url, data, need_sign = true }) {
      try {
        if (typeof data === 'object' && process.env.VUE_APP_ENABLE_SIGN && need_sign) {
          let sign = md5(JSON.stringify(data));
          data.S = aes.encrypt(sign.toString().toUpperCase(), url).toString();
        }
        let res = await api.post(url, data);
        if (res) {
          // 兼容新接口格式 { code: 10000, data: {...} } - 针对新版接口
          if (res.code === 10000 && res.data && (url.includes('/api/login') || url.includes('/api/vpai/'))) {
            return res.data;
          }
          // 旧接口格式 { IsSuccess: true, Data: {...} }
          if (res.IsSuccess) {
            if (Array.isArray(res.Data)) {
              return {
                List: res.Data,
                Paging: res.Paging
              };
            } else {
              return res.Data;
            }
          } else {
            throw new Error(res.ErrorMsg || res.message || '请求失败');
          }
        }
      } catch (error) {
        throw error;
      }
    }
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage
    })
  ]
});
